/* oxlint-disable */
'use client';

import React, { useEffect, useState } from 'react';

import Image from 'next/image';

// import { useRouter } from 'next/navigation';
import { useRouter } from 'next/navigation';

import { HiOutlineCurrencyDollar } from 'react-icons/hi2';
import { IoHeartOutline, IoHeartSharp } from 'react-icons/io5';

// import FirstGameModal from '@/components/modals/FirstGameModal';

import { updateFavoriteGames } from '@/features/casino/services';
import { useAuthStore } from '@/stores/userStore';
import { userUIStore } from '@/stores/userUIStore';

import { isGameCurrencyMismatch } from '@/utils/currency';
import { getDatGames } from '@/utils/helpers';

import { useAuth } from '@/core/auth/client/AuthProvider';
import { handleLoginModal } from '../casino/utils';
import AcceptModal from '../modals/AcceptModal';

import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';

const CarouselGames = () => {
  const [favorites, setFavorites] = useState<string[]>([]);
  const [dataGames, setDataGames] = useState<any[]>([]);
  const [isAcceptModalUrl, setIsAcceptModalUrl] = useState<string>('');
  const { session } = useAuth();
  const {
    account,
    balance,
    updateFavoriteGames: UpdateFavoriteGamesStore,
  } = useAuthStore();
  const userCurrency = account?.currency || 'USD';

  const {
    toggleLoginModal,
    toggleDepositModal,
    toggleDepositSheet,
    toggleAcceptModal,
  } = userUIStore();
  const router = useRouter();

  useEffect(() => {
    const getFavorites = async () => {
      const savedFavorites = account.favoriteGames;
      if (savedFavorites && savedFavorites.length > 0) {
        const data = await getDatGames(savedFavorites, 'home');
        setDataGames(data.gameData);
        setFavorites(savedFavorites);
      }
    };
    getFavorites();
  }, [account.favoriteGames]);

  const isFavorite = (gameCode: string) => {
    return favorites.includes(gameCode);
  };

  const toggleFavorite = async (gameCode: string) => {
    if (!session) {
      toggleLoginModal();
    } else if (isFavorite(gameCode)) {
      const newFavorites = favorites.filter((code) => {
        return code !== gameCode;
      });
      const updatedFavorites = await updateFavoriteGames(newFavorites);
      setFavorites(updatedFavorites);
      UpdateFavoriteGamesStore(updatedFavorites);
      if (newFavorites.length === 0) {
        window.location.reload();
      }
    } else {
      const newFavorites = [...favorites, gameCode];
      setFavorites(newFavorites);
      const updatedFavorites = await updateFavoriteGames(newFavorites);
      UpdateFavoriteGamesStore(updatedFavorites);
      if (newFavorites.length === 0) {
        window.location.reload();
      }
    }
  };

  const handleLoginModalProps = {
    session,
    account,
    balance,
    toggleLoginModal,
    toggleDepositModal,
    toggleDepositSheet,
    toggleAcceptModal,
    setIsAcceptModalUrl,
    router,
  };

  return (
    <div>
      <div className="w-full flex flex-wrap justify-evenly mt-10">
        {dataGames.map((item, index) => {
          const imageUrl = (item.thumb_url || '/img/v2/casino/onError.webp');
          const categorySelected = 'favoritos';
          return (
            <Card
              className="md:mx-2 max-md:ml-1 bg-transparent p-0 border-none flex justify-center items-center h-full rounded-lg w-60 max-md:w-36 max-sm:w-28"
              key={item.identifier}
            >
              <CardContent className="w-full text-sivarbet-text p-0 flex flex-col justify-center items-center rounded-lg">
                <div className="w-full flex items-center justify-center relative group aspect-square">
                  <Image
                    className="w-full rounded-xl h-full cursor-pointer transition duration-300 ease-in-out hover:opacity-55"
                    src={imageUrl}
                    alt={item.title}
                    width={200}
                    height={0}
                  />
                  <div className="flex absolute top-[5px] right-1 w-fit rounded-sm overflow-hidden shadow-xs shadow-black">
                    {item.sections?.nuevos && (
                      <span className="text-sivarbet-border md:text-xs text-[10px] bg-green-500 md:px-2 p-0.5 md:font-semibold">
                        Nuevo
                      </span>
                    )}
                    {item.sections?.popular && (
                      <span className="text-sivarbet-border md:text-xs text-[10px] bg-yellow-500 md:px-2 p-0.5 md:font-semibold">Popular</span>
                    )}
                    {item.sections?.recomendados && (
                      <span className="text-sivarbet-border md:text-xs text-[10px] bg-red-600 md:px-2 p-0.5 md:font-semibold">Top</span>
                    )}
                  </div>
                  <Button
                    type="button"
                    className="hidden absolute shadow-xl shadow-black bg-[radial-gradient(circle,rgb(236,4,140)_60%,rgb(255,26,155)_100%)] opacity-80 text-sivarbet-border group-hover:block font-semibold"
                    onClick={() => {
                      handleLoginModal({
                        ...handleLoginModalProps, item, categorySelected, gameIndex: index,
                      });
                    }}
                  >
                    Jugar
                  </Button>
                </div>
                <div className="w-full flex items-center justify-between pt-1">
                  <p
                    className="text-base max-md:text-xs max-md:font-normal font-medium text-sivarbet-text overflow-hidden whitespace-nowrap text-ellipsis w-3/4 max-w-[200px] max-lg:max-w-[120px] max-md:max-w-[110px] max-sm:max-w-[100px]"
                    title={item.title}
                  >
                    {item.title}
                  </p>
                  <div className="flex items-center">
                    {isGameCurrencyMismatch(userCurrency, item.currency) && (
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <Button className="bg-transparent h-0 p-0 hover:bg-transparent">
                              <HiOutlineCurrencyDollar className="text-xl text-sivarbet-secondary" />
                            </Button>
                          </TooltipTrigger>
                <TooltipContent className="bg-sivarbet-secondary-bg text-sivarbet-primary border-sivarbet-border">
                  <p>Este juego es solo en USD</p>
                </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    )}
                    <Button
                      type="button"
                      className="bg-transparent h-0 hover:bg-transparent px-0"
                      onClick={() => {
                        return toggleFavorite(item.identifier);
                      }}
                    >
                      {isFavorite(item.identifier) ? (
                        <IoHeartSharp className="text-red-600 text-xl max-md:text-base" />
                      ) : (
                        <IoHeartOutline className="text-xl max-md:text-base" />
                      )}
                    </Button>
                  </div>
                </div>
                <div className="w-full text-start mb-3">
                  <span className="text-sm max-md:text-xs text-sivarbet-secondary">
                    {item.producer}
                  </span>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <AcceptModal url={isAcceptModalUrl} />
    </div>
  );
};

export default CarouselGames;
